import { RouterHelperService } from './../../../core/services/router-helper/router-helper.service';
import { Component, Input } from '@angular/core';
import {
  IContentBuilderFieldColor,
  IContentBuilderFieldImage,
} from '@core/models/content-builder-fields.model';
import { Router } from '@angular/router';
import { AnalyticsService } from '@core/services/app/analytics.service';

@Component({
  selector: 'app-big-push-block',
  templateUrl: './big-push-block.component.html',
})
export class BigPushBlockComponent {
  @Input() heading?: string;
  @Input() text?: string;
  @Input() buttonLabel?: string;
  @Input() buttonLink?: string;
  @Input() icon?: IContentBuilderFieldImage;
  @Input() backgroundColor?: IContentBuilderFieldColor;
  @Input() externalLink?: boolean;

  constructor(
    private readonly router: Router,
    private readonly routerHelper: RouterHelperService,
    private readonly analyticsService: AnalyticsService,
  ) {}

  buttonClick(_$event: Event): void {
    if (this.externalLink && this.buttonLink) {
      this.analyticsService.log({
        level: 'debug',
        label: '#DOOD-1250 Navigate',
        message: {
          from: 'BigPushBlockComponent Ligne°31',
          target: this.buttonLink,
          currentLocation: window.location.pathname,
        },
      });
      window.location.href = this.buttonLink;
    } else {
      this.analyticsService.log({
        level: 'debug',
        label: '#DOOD-1250 Navigate',
        message: {
          from: 'BigPushBlockComponent Ligne°32',
          target: [
            this.buttonLink ? this.routerHelper.translateRoute(this.buttonLink) : this.buttonLink,
          ],
          currentLocation: window.location.pathname,
        },
      });
      this.router.navigate([
        this.buttonLink ? this.routerHelper.translateRoute(this.buttonLink) : this.buttonLink,
      ]);
    }
  }
}
